import { CONSTANTS } from 'src/environments/constants';
import { DirectoryConfig, DirectoryField, DirectoryFieldForSheet, DirectorySheet } from 'src/app/directory/models/directory-config.model';
import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { DirectorySearchService } from '../../services/directory-search/directory-search.service';
import { DirectorySharedDataService } from '../../services/directory-shared-data.service';
import { DirectoryEntityContactDialogComponent } from '../dialog/directory-entity-contact-dialog/directory-entity-contact-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { Observable, of } from 'rxjs';
import { concatMap } from 'rxjs/operators';
import { isLinkToItem } from '../../models/fields/field.model';
import { TranslateService } from '@ngx-translate/core';

// TODO: this is no longer use and therefore should be removed soon. Just keeping it in case the changes done in
// DirectorySecondarySheetComponent's template have unexpected side effects and this needs to be used again
// but it really shouldn't...
@Component({
  selector: 'app-directory-adb',
  templateUrl: './directory-adb.component.html',
  styleUrls: ['./directory-adb.component.scss']
})
export class DirectoryAdbComponent implements OnInit, OnChanges {
  public CONSTANTS = CONSTANTS;
  public widgetConfig: DirectoryConfig;

  @Input() range: string;
  @Input() id: string;
  @Input() config: DirectoryConfig;

  public elementValues: any;
  public fieldsId: any = [];
  // public currentAdbFields: any = [];

  public sheetToUse: DirectorySheet;
  public summary: any = {};
  public filteredFieldsGroups: any[] = [];
  public isLinkToItemModel = isLinkToItem;
  public currentLang: string;

  constructor(
    private directorySearch: DirectorySearchService,
    private directoryData: DirectorySharedDataService,
    public dialog: MatDialog,   
    public translateService: TranslateService 
  ) {}

  ngOnInit(): void {
    this.directoryData
      .getDirectoryConfig()
      .subscribe((config) => (this.widgetConfig = config));
  }

  ngOnChanges() {
    if(this.id && this.range) {
      this.sheetToUse = this.findSheetToUse(this.config);
      this.currentLang = this.translateService.currentLang;

      let showAllBlocks: boolean = false;
      if (this.widgetConfig?.layout?.showEmptyBlocks) {
        showAllBlocks = this.widgetConfig.layout.showEmptyBlocks;
      }

      this.directorySearch.getAdbElement(this.range, this.id).subscribe(
        (element) => {
          this.elementValues = element;
          this.fieldsId = Object.keys(element);
          // Set the header/summary values
          if (this.sheetToUse.classId) {
            this.mapFieldValue('title', this.sheetToUse.title);
            this.mapFieldValue('description', this.sheetToUse.description);
            this.mapFieldValue('logo', this.sheetToUse.logo);
            this.mapFieldValue('banner', this.sheetToUse.banner);
          } else {
            this.mapFieldValue('title', { id: CONSTANTS.name, code: CONSTANTS.name, type: "Textarea" }); // No sheet available -> force using the name property as defined in the constants
            this.mapFieldValue('description', null);
            this.mapFieldValue('logo', null);
            this.mapFieldValue('banner', null);
          }

          // // Set the values in the proper fields. Where are the fieldgroups though?
          // let allConfiguredFields = this.setAllconfiguredFields();
          // this.currentAdbFields = [];
          // this.fieldsId.forEach(id => {
          //   this.currentAdbFields.push(
          //     allConfiguredFields.find(x => x.id === id)
          //   );
          // });

          this.filterFieldsThenGroups(this.sheetToUse.fieldsgroup, this.range, showAllBlocks);
        }
      )
    }
  }

  private findSheetToUse(directoryConfig: DirectoryConfig): DirectorySheet {
  if (directoryConfig.layout.onlySpecificFields) {
    // console.debug("Finding sheet for only specific field", directoryConfig.secondarySheets);
    // console.debug("Comparing with", this.range);
    // console.debug("Result from the find", directoryConfig?.secondarySheets?.find(adb => { return adb.classId == this.range; }));
    const toReturn: DirectorySheet = directoryConfig?.secondarySheets?.find(adb => { return adb.classId == this.range; });
    if (toReturn !== undefined) {
      return toReturn;
    }
  }

    // By default, return the widget's main sheet
    // console.debug("Using widget's main sheet for lack of anything better");
    return directoryConfig.sheet;
  }

  private mapFieldValue(property: string, field: DirectoryField) {
    if (field && field.id) {
      this.summary[property] = {
        field: field,
        value: field.id in this.elementValues ? this.elementValues[field.id] : null
      };
    } else {
      this.summary[property] = null;
    }
  }

  canContact() {
    if (this.widgetConfig && this.widgetConfig.requests.hasContactRequests 
        && this.widgetConfig.requests.contact.code && this.elementValues 
          && this.elementValues[this.widgetConfig.requests.contact.code]) {
      return true;
    }
    return false;
  }

  public openContactDialog(contact?: DirectoryField) {
    let contactCode = this.widgetConfig.requests.contact.code;
    let contactEmail;
    if(this.elementValues[contactCode]) {
      contactEmail = this.elementValues[contactCode];
    } else {
      contactEmail = this.widgetConfig.responsibleEmail;
    }
    if(contactEmail) {
      const dialogRef = this.dialog.open(DirectoryEntityContactDialogComponent, {
        width: '600px',
        maxWidth: '100vw',
        maxHeight: '90vh',
        data: {
          entity_id: this.id,
          entity_name: this.elementValues[CONSTANTS.name],
          widget_name: this.widgetConfig.name,
          referer: document.referrer,
          contact_email: contactEmail
        },
        autoFocus: false,
        disableClose: true,
      });
      dialogRef.afterClosed().subscribe((success: string) => {});
    }
  }

  /**
   * This is equivalent (although much simpler) to DirectoryEntityComponent::filterFieldsThenGroups
   */
  setAllconfiguredFields(): DirectoryFieldForSheet[] {
    let allConfiguredFields = []
    let fieldsGroups = this.sheetToUse.fieldsgroup;

    fieldsGroups.forEach(fg => {
      allConfiguredFields = [...allConfiguredFields, ...fg.fields];
    });
    return allConfiguredFields;
  }

  public urlEnc(url: string) {
    return encodeURI(url);
  }

  public filterFieldsThenGroups(fieldsGroups, range: string, showAllBlocks: boolean) {
    //this.showFields = false;
    this.filteredFieldsGroups = [];
    // console.log("Current entity data", this.elementValues);
    if (range == '') range = null;

    fieldsGroups.forEach((group) => {
      let newGroup = { order: group.order, title: group.title, fields: [] };

      // If settings ask to display empty blocks, add them here
      if (showAllBlocks) {
        // console.log("All blocks will be shown");
        this.filteredFieldsGroups.push(newGroup);
      }

      // console.log("Current entity", this.elementValues);
      // console.log("Current sheet", this.sheetToUse);
      group.fields.forEach((field) => {
        let fieldDomain = field.domain;
        if (fieldDomain == undefined) { // This was needed for entities. Not sure this is useful here
          fieldDomain = null;
        }

        if ((fieldDomain === range && field.id != 'core_hasListName') //Entities and ADB without 'core_hasListName'
          || (range != null && field.id == 'core_hasListName')) { //Specific to ADB with 'core_hasListName'

          // console.log("Trying to push field", field);
          if (field.showFieldWhenNoValue) // IF the field is supposed to be shown even without a value
          { // THEN always show field
            newGroup.fields.push(field);
            // console.debug("Field " + field.id + " can be displayed even without a value");
            // If the group wasn't already added to the list of groups, then add it now
            if (this.filteredFieldsGroups.indexOf(newGroup) == -1) {
              // console.log("Pushing group ");
              // console.log(newGroup.title);
              this.filteredFieldsGroups.push(newGroup);
            }
          } else if (this.elementValues.hasOwnProperty(field.id)) { // OTHERWISE IF the element to display has a value defined for this field
            this.fieldReallyHasValue(field).subscribe(reallyHasValue => {
              if (reallyHasValue) {
                // console.debug("Field "+field.id+" can be displayed because is has a value");
                // console.debug("Field", field);
                newGroup.fields.push(field);
                // If the group wasn't already added to the list of groups, then add it now
                if (this.filteredFieldsGroups.indexOf(newGroup) == -1) {
                  // console.log("Pushing group ");
                  // console.log(newGroup.title);
                  this.filteredFieldsGroups.push(newGroup);
                }
              } else {
                // console.debug("Field should not be displayed", field);
              }
            });
          }
        }
      });
    });
    // console.debug("Fields AFTER filtering");
    // console.debug(this.filteredFieldsGroups);
    return this.filteredFieldsGroups;
  }

  private fieldReallyHasValue(field: any): Observable<boolean> {
    // console.debug("Starting fieldReallyHasValue", field);

    if (!this.isLinkToItemModel(field.type)) { // has a value and is not a link to a potentially restricted list of items
      // console.debug("Safe field");
      return of(true);
    }

    const currentValue = this.elementValues[field.id];
    // console.debug("Field value", currentValue);
    const fieldRange = field.range;
    return this.directorySearch.getAllowedItems(field.range).pipe(
      concatMap(allowedIds => {
        // console.debug("Allowed ids for "+ field.range, allowedIds);
        if (Array.isArray(currentValue)) { // multiple values to test
          for (let index = 0; index < currentValue.length; index++) {
            const element = currentValue[index];
            if (allowedIds.includes(element.element_id)) {
              return of(true);
            }
          }
          return of(false);
        } else {
          if (field.range == null || field.range == undefined) { // specific way the unique entities values are stored
            return of(allowedIds.includes(currentValue));
          } else {
            return of(allowedIds.includes(currentValue.element_id));
          }
        }
      })
    );
  }

  public translationCompatibilityForOlderWidget(objectOrString, lang): {} {
    if (typeof objectOrString !== 'object') {
      let tempValue = objectOrString
      objectOrString = {};
      objectOrString[lang] = tempValue;
    }
    return objectOrString[lang];
  }

}
